import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ActionDialogComponent } from './components/action-dialog/action-dialog.component';
import { ModifyReservationsComponent } from './components/modify-reservations/modify-reservations.component';
import { ModifyReservationsService } from './services/modify-reservations.service';
import { RoomSelectionComponent } from './components/room-selection/room-selection.component';
import { CompareReservationComponent } from './components/compare-reservation/compare-reservation.component';
import { GuestDetailsComponent } from './components/guest-details/guest-details.component';
import { AppMaterialModule } from './vendor/app-material.module';
import { ValidateLoyaltyService } from './legacy-bookexpress/services/validate-loyalty.service';
import { GoogleAnalyticsEventsService } from './legacy-bookexpress/services/google-analytics-events.service';
import { LegacyBookInitService } from './legacy-bookexpress/services/legacy-book-initializer.service';
import { CasinoPlayerService } from './legacy-bookexpress/services/casino-player.service';
import { FormsModule } from '@angular/forms';
import { RoomlistService } from './legacy-bookexpress/services/RoomList.service';
import { ReservationService } from './legacy-bookexpress/services/reservation.service';
import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { CurrencyService } from './legacy-bookexpress/services/currency.service';
import { DirectivesModule } from 'app/shared/directives/directives.module';
import { SharedService } from './legacy-bookexpress/services/shared.service';
import { LogoutService } from './legacy-bookexpress/services/logout.service';
import { ToasterService } from 'angular2-toaster';
import { PreloaderService } from './legacy-bookexpress/services/preloader.service';
import { BookService } from './legacy-bookexpress/services/book.service';
import { LoaderComponent } from './components/loader/loader.component';
import { CommonConfirmationDialogueComponent } from './components/common-confirmation-dialogue/common-confirmation-dialogue.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CardProcessingService } from './legacy-bookexpress/services/card-processing.service';
import { DialogComponent } from './components/angular-material/dialog/dialog.component';

@NgModule({
  declarations: [
    ActionDialogComponent,
    ModifyReservationsComponent,
    RoomSelectionComponent,
    CompareReservationComponent,
    GuestDetailsComponent,
    LoaderComponent,
    CommonConfirmationDialogueComponent,
    PaymentComponent,
    DialogComponent,
  ],
  imports: [CommonModule, DirectivesModule, AppMaterialModule, FormsModule, CommonPipesModule],
  exports: [AppMaterialModule],
  providers: [
    ModifyReservationsService,
    ValidateLoyaltyService,
    GoogleAnalyticsEventsService,
    LegacyBookInitService,
    CasinoPlayerService,
    RoomlistService,
    CardProcessingService,
    ReservationService,
    CurrencyService,
    SharedService,
    DecimalPipe,
    LogoutService,
    ToasterService,
    PreloaderService,
    CasinoPlayerService,
    BookService,
  ],
})
export class SharedModule {}
